import React from 'react'
import { string, func } from 'prop-types'
import classnames from 'classnames'
import DoxFileIcon from '../graphics/doxFileIcon';
import useFileDragDrop from '../hooks/useFileDragDropHook';
import { AcceptedFileExts } from '../../Shared/resources/DoxFileTypes';
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook';

const DoxFileSelector = ({ onFilesSelected, layoutType = 'desktop' }) => {

    const translateString = useTranslationContext()

    const fileList = [] // todo: will we ever want to append to this list?
    const acceptedFileTypes = AcceptedFileExts.join(',')

    const updateUploadFileList = files => {
        let newFileList = [...fileList]

        if (files && files.length > 0) {
            const existingFileNames = fileList.map(f => f.name)

            for (let i = 0; i < files.length; i++) {
                if (!existingFileNames.includes(files[i].name)) {
                    newFileList.push(files[i])
                }
            }

            onFilesSelected(newFileList)
        }
    }

    const handleFilesSelected = e => {
        updateUploadFileList(e.target.files)
    }

    const { handleDragEnter, handleDragLeave, handleDragOver, handleDrop, inDropZone } = useFileDragDrop(updateUploadFileList)

    return (
        <div className='dox-file-selector-panel'
            onDrop={e => handleDrop(e)}
            onDragOver={e => handleDragOver(e)}
            onDragEnter={e => handleDragEnter(e)}
            onDragLeave={e => handleDragLeave(e)}>
            {layoutType === 'desktop' &&
                <div className={classnames('drop-zone', { 'active': inDropZone })}>
                    <DoxFileIcon />
                <label htmlFor='dox-file-upload'>
                    <span>{translateString('Dox.DocumentUploader.SelectFilesLabel.Desktop')} <a>{translateString('Dox.DocumentUploader.BrowseDeviceLink.Desktop') }</a></span>
                        <input id='dox-file-upload' type="file" onChange={handleFilesSelected} accept={acceptedFileTypes} multiple />
                    </label>
                </div>
            }
            {layoutType !== 'desktop' &&
                <label htmlFor='dox-file-upload'>
                    <DoxFileIcon />
                    <span>{translateString(
                        'Dox.DocumentUploader.SelectFilesLabel.Mobile',
                        { BrowseDeviceLink: <span className='dox-link bold inline'>{translateString('Dox.DocumentUploader.BrowseDeviceLink.Mobile')}</span> })}
                    </span>
                    <input id='dox-file-upload' type="file" onChange={handleFilesSelected} accept={acceptedFileTypes} multiple />
                </label>
            }
        </div>
    );
}

DoxFileSelector.propTypes = {
    layoutType: string.isRequired,
    onFilesSelected: func.isRequired
}

export default DoxFileSelector